import React, { useEffect, useState } from "react";
import { useApi } from "../../../../common/hooks";
import { FeatureManagementService } from "../../../../api";
import styles from "./DSIFeatureFlags.module.css";
import { isNonEmptyArray } from "../../../../common/utils";
import { HeaderRow, FeatureFlagRow, FeatureSearch } from "./components";
import { FLAGS } from "../../../../common/providers/feature-flag-provider";

const DSIFeatureFlags = () => {
	const { call: getAllInstanceFeatureFlags } = useApi(FeatureManagementService.getAllInstanceFeatureFlags);
	const { call: updateInstanceFeatureFlags } = useApi(FeatureManagementService.updateInstanceFeatureFlags);
	const [features, setFeatures] = useState([]);
	const [name, setName] = useState("");
	useEffect(() => {
		getAllInstanceFeatureFlags()
			.then((res) => setFeatures(res.filter((f) => f.code !== FLAGS.BACK_OFFICE)))
			.catch(console.error);
	}, [getAllInstanceFeatureFlags]);
	const handleSwitchHandler = (feature) => {
		updateInstanceFeatureFlags({ code: feature.code }, { enabled: !feature.active })
			.then(() => {
				setFeatures((prev) =>
					prev.map((f) => (f.code === feature.code ? { ...f, active: !feature.active } : f))
				);
			})
			.catch(console.error);
	};

	const handleDescriptionUpdate = (feature, newDescription) => {
		updateInstanceFeatureFlags({ code: feature.code }, { description: newDescription })
			.then(() => {
				setFeatures((prev) =>
					prev.map((f) => (f.code === feature.code ? { ...f, description: newDescription } : f))
				);
			})
			.catch(console.error);
	};
	const handleChangeSearchValue = (value) => {
		setName(value);
	};
	return (
		<div className={styles.container}>
			<FeatureSearch name={name} onChangeSearchValue={handleChangeSearchValue} />
			<HeaderRow />
			<div className={styles.list}>
				{isNonEmptyArray(features) &&
					features
						.filter((f) => f.code.toLowerCase().includes(name.toLowerCase()))
						.map((f) => (
							<FeatureFlagRow
								key={f.code}
								feature={f}
								onDescriptionUpdate={handleDescriptionUpdate}
								onSwitchHandler={handleSwitchHandler}
							/>
						))}
			</div>
		</div>
	);
};

export default DSIFeatureFlags;
